import React from 'react';
import clientInformation, { getClientItem } from '../login/ClientInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, CheckCustomerData } from "../../services/AuthenticationService";
import { useParams } from 'react-router-dom';
import { onlyNumbers, BonusString } from '../helpers/common';
import { EWalletDeposit } from "../../services/DepositService";
import Bonus from '../Bonus';
import { isMobile } from 'react-device-detect';
import { MissingAccountInfo } from "../deposit/MissingAccountInfo.jsx";
import iframeResizer from 'iframe-resizer';
import swal from 'sweetalert2';

export const R4Conecta = () => {
    const clientInfo = clientInformation();
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    let INSTANCEID = clientInfo.InstanceID;
    let url = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    const { id } = useParams();
    const [arrayRegularDeposits, setRegularDeposits] = useState(JSON.parse(getClientItem('ArrayRegularMethods')).filter(function (element) { return element.DepositID == id; })[0]);
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [showiFrame, setshowiFrame] = useState(false);
    const [showFrameTitle, setShowFrameTitle] = useState(true);
    const [showForm, setshowForm] = useState(true);
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [arrayEwallet, setArrayEwallet] = useState([]);
    const [isValidate, setIsValidate] = useState(true);
    const [isSecureIdVisible, setIsSecureIdVisible] = useState(false);
    const [isAccountVisible, setIsAccountVisible] = useState(false);
    const [height, setHeight] = useState('500px');
    const iframeRef = React.useRef(null);
    const lastHeightRef = React.useRef(0);
    const debounceTimeout = React.useRef(null);
    const [shouldScroll, setShouldScroll] = useState(false);
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(function (response) {
            validateFields();
            doCheckCustomerData();

        })
            .catch(function (error) {
                navigate('/expired/');
            })
        if (arrayRegularDeposits == undefined) {
            navigate('/deposits/');
        }

        // Funci�n para copiar el n�mero de referencia
        window.copyReferenceNumber = function (refNum) {
            navigator.clipboard.writeText(refNum).then(() => {
                const feedbackDiv = document.getElementById('copyFeedback');
                if (feedbackDiv) {
                    feedbackDiv.style.display = 'inline';
                    feedbackDiv.style.color = 'green';
                    feedbackDiv.textContent = 'Copied!';

                    setTimeout(() => {
                        feedbackDiv.style.display = 'none';
                    }, 2000);
                }
            });
        }
        const handleMessage = (event) => {
            // Optional: Validate origin
            // if (event.origin !== 'https://trusted-site.com') return;

            const data = event.data;
            if (data && data['full-content-height']) {
                setShowFrameTitle(false);
                const newHeight = parseInt(data['full-content-height'], 10);

                // Clamp to reasonable range (e.g., 300px to 900px)
                if (newHeight < 300 || newHeight > 900) return;

                // Debounce to avoid rapid resizing
                if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current);
                }

                debounceTimeout.current = setTimeout(() => {
                    // Only update if height actually changed
                    if (newHeight !== lastHeightRef.current) {
                        lastHeightRef.current = newHeight;
                        setHeight(`${newHeight}px`);
                    }
                }, 300);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };



    }, [])


    function handleResponseFromComponent(response) {
        setIsValidate(response);
    }

    async function validateFields() {
        switch (arrayRegularDeposits.ImageName.toLowerCase()) {
            case "paysafecard":
            case "bitcoin":
            case "marketusa":
            case "wipay":
            case "changelly":
            case "wallet88":
            case "quickbuy":
            case "flashteller":
            case "triplewallet":
            case "majestic":
            case "applepay":
            case "googlepay":
            case "cashapp":
            case "paypal":
            case "venmo":
            case "zelle":
            case "moonpay":
            case "alphapaysonramp":
            case "tylt":
            case "paycash":
            case "cocoav2":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('700px');
                }
                break;
            case "wallet88emt":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('700px');
                }
                break;
            case "quickervoucherv2":
            case "kribatta":

                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('900px');
                }
                break;
            case "fastgateway":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('550px');
                    setShouldScroll(true);
                }
                break;
            default:
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(true);
                }
                break;
        }
    }

    async function doCheckCustomerData() {
        await CheckCustomerData(getClientItem('Token'), arrayRegularDeposits.DepositID).then(async function (response) {
            if (!response.Authentication.AllComplete) {
                setIsValidate(true);
            }
            else {
                setIsValidate(false);
            }
        })
    };

    if (isValidate) {
        return <MissingAccountInfo Processor={arrayRegularDeposits.DepositID} isValidate={handleResponseFromComponent.bind(isValidate)} />;
    }

    async function doEWalletDeposit(Amount, Account, SecureID) {
        console.log(Amount);
        var Data =
        {
            "Token": getClientItem('Token'),
            "eWalletAccount": Account,
            "eWalletPassword": SecureID,
            "ProcessorName": arrayRegularDeposits.DepositName,
            "InstanceID": INSTANCEID,
            "Amount": Amount,
            "CurrencyCode": "USD",
            "returnURL": "",
            "statusURL": "",
            "TransactionID": "-1",
            "IPv4Address": clientInfo.IPAddress,
            "BonusList": BonusString(JSON.parse(getClientItem('ArrayBonus')))
        };
        console.log(Data);
        await EWalletDeposit(Data).then(function (response) {

            setArrayEwallet(response.Authentication);

            if (response.Authentication.ErrorCode != undefined && response.Authentication.ErrorCode != null) {

                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error with eWallet Deposit', response.Authentication.ErrorDescription, 'error');
                }
                else {
                    Alerts.ShowAlert('Error with eWallet Deposit', response.Authentication.ErrorDescription, 'error');
                }

            }
            else {
                var message = response.Authentication.HtmlResponse;
                if (response.Authentication.status == "PENDING") {
                    var Link = response.Authentication.Descriptor;
                    if (Link != "" && Link != undefined && URL.canParse(Link)) {
                        if (arrayRegularDeposits.ImageName.toLowerCase() == 'alphapaysonramp') {
                            window.open(Link, "_blank");
                        }
                        else {
                            setshowiFrame(true);
                            setshowForm(false);
                            forceUpdate();
                        }
                    }
                    else {
                        if (arrayRegularDeposits.ImageName.toLowerCase() == 'premierint' ||
                            arrayRegularDeposits.ImageName.toLowerCase() == 'premieret' ||
                            arrayRegularDeposits.ImageName.toLowerCase() == 'triplewallet' ||
                            arrayRegularDeposits.ImageName.toLowerCase() == 'premierplus') {
                            message += response.Authentication.Descriptor;

                            if (isMobile) {
                                Alerts.ShowAlertFullScreen('Deposit Pending', message, 'info');
                            }
                            else {
                                Alerts.ShowAlert('Deposit Pending', message, 'info');
                            }
                        }
                        if (arrayRegularDeposits.ImageName.toLowerCase() == 'paycash') {
                            //message = "Your Paycash reference number is: " + response.Authentication.Descriptor + "<br><br>Once the deposit is completed, your balance will be updated."; 
                            message = "Your Paycash reference number is:<br><div style='display: flex; align-items: center; justify-content: center; gap: 10px; margin: 15px 0;'><span id='refNumber' style='font-size: 22px; font-weight: bold; color: #333;'>" + response.Authentication.Descriptor + "</span><button onclick=\"copyReferenceNumber('" + response.Authentication.Descriptor + "')\" style='background: none; border: none; cursor: pointer; font-size: 18px; padding: 5px; color: #007bff;' title='Copy to clipboard'><i class='fas fa-copy'></i></button><span id='copyFeedback' style='display: none; font-size: 14px; margin-left: 10px;'></span></div>Once the deposit is completed, your balance will be updated.";
                            if (isMobile) {
                                Alerts.ShowAlertFullScreen('Deposit Pending', message, 'info');
                            }
                            else {
                                Alerts.ShowAlert('Deposit Pending', message, 'info');
                            }
                        }
                        else {
                            message += "<br/><br/><div class='bitcoinaddress'>Address: <b>" + response.Authentication.Descriptor + "</b></div>";
                            if (response.Authentication.Notes !== 'undefined' && response.Authentication.Notes != '')
                                message += "<br/><br/><div class='bitcoinaddress'>Please deposit the following btc amount:<br/> <b>" + response.Authentication.Notes + "</b></div>";

                            if (isMobile) {
                                Alerts.ShowAlertFullScreen('eWallet Deposit Completed', message, 'info');
                            }
                            else {
                                Alerts.ShowAlert('eWallet Deposit Completed', message, 'info');
                            }

                        }
                    }
                }
                else if (response.Authentication.status == "REJECTED") {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('eWallet Deposit Rejected', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('eWallet Deposit Rejected', message, 'info');
                    }

                }
                else {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('eWallet Deposit Completed', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('eWallet Deposit Completed', message, 'info');
                    }
                }

            }

        })
            .catch(function (error) {
                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error', 'Error making deposit', 'error');
                }
                else {
                    Alerts.ShowAlert('Error', 'Error making deposit', 'error');
                }

            })


    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, accountoremail, secureid } = Object.fromEntries(data.entries());
            if (amount != '') {
                setIsProcessing(true);
                await doEWalletDeposit(amount, accountoremail, secureid);
                setIsProcessing(false);
            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }
        }
    }

    /*const handleIframeLoad = () => {
        try {
            setShowFrameTitle(false);
            iframeResizer({}, iframeRef.current);
        } catch (error) {
            console.warn('iframe-resizer failed to initialize, applying default height:', error);
            iframeRef.current.style.height = '700px'; // Set default height
        }
    };*/

    const handleIframeLoad = () => {
        setShowFrameTitle(false);
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px", }} src={"/svg/" + arrayRegularDeposits.ImageName + ".svg"} /> <span> Pago M&oacute;vil </span>
                    </span>
                </div>
                {showForm && <div >
                    <div className="row">
                        <div className="col-md-2">&nbsp;</div>
                        <div className="col-md-12 col-sm-12 col-xs-12 mb-3">
                            <div className="input-group">
                                <div className="alert alert-primary" role="alert" style={{ width: "100%" }}>
                                    <p>
                                        Realiza tu acreditaci&oacute;n sin complicaciones a trav&eacute;s de pago m&oacute;vil R4
                                    </p>
                                    <p>
                                        <strong>C&eacute;dula de identidad (RIF): </strong> J-405427230  <br />
                                        <strong>N&uacute;mero celular: </strong>04143144524   <br />
                                        {/*<strong>CI: </strong>{getClientItem('SSN')}   <br />*/}                                        
                                        <strong>Banco: </strong>R4 / Banco Microfinanciero  <br />
                                        
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">&nbsp;</div>
                    </div>

                </div>}
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >
                        <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                            <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/deposits/')}>BACK</button>
                           
                        </div>
                    </div>
                </div>
            </form >
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>

    );
}